const template = {
  displayField: 'bodyText',
  name: 'template',
  description: 'Contentful new schema template',
  fields: [
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'template',
    version: 18,
    updatedAt: '2023-03-03T22:24:06.970Z'
  }
};
export default template;